export enum DocumentFlux {
	Receive = 1,
	Transmission = 2,
	Upload = 3,
}
